import { render, staticRenderFns } from "./ContentWrapper.vue?vue&type=template&id=c62cee2c&scoped=true"
import script from "./ContentWrapper.vue?vue&type=script&lang=js"
export * from "./ContentWrapper.vue?vue&type=script&lang=js"
import style0 from "./ContentWrapper.vue?vue&type=style&index=0&id=c62cee2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c62cee2c",
  null
  
)

export default component.exports